import type {
  AssetsTransport,
  CompleteAssetUploadInput,
  DeleteAssetInput,
  GetAssetByIdInput,
  ListAssetsInput,
  ListAssetsResult,
  PrepareAssetUploadResult,
  TransportPrepareUploadInput,
  UpdateAssetInput,
  AssetRecord,
} from './types';

export function createTrpcAssetsTransport(client: { assets: any }): AssetsTransport {
  return {
    prepareUpload: async (
      input: TransportPrepareUploadInput,
    ): Promise<PrepareAssetUploadResult> => {
      const response = (await client.assets.prepareUpload.mutate(
        input,
      )) as PrepareAssetUploadResult;
      return response;
    },

    completeUpload: async (input: CompleteAssetUploadInput): Promise<AssetRecord> => {
      const response = (await client.assets.completeUpload.mutate(input)) as AssetRecord;
      return response;
    },

    list: async (input: ListAssetsInput): Promise<ListAssetsResult> => {
      const response = (await client.assets.list.query(input)) as ListAssetsResult;
      return response;
    },

    getById: async (input: GetAssetByIdInput): Promise<AssetRecord> => {
      const response = (await client.assets.getById.query(input)) as AssetRecord;
      return response;
    },

    update: async (input: UpdateAssetInput): Promise<AssetRecord> => {
      const response = (await client.assets.update.mutate(input)) as AssetRecord;
      return response;
    },

    delete: async (input: DeleteAssetInput): Promise<AssetRecord> => {
      const response = (await client.assets.delete.mutate(input)) as AssetRecord;
      return response;
    },
  };
}
